export interface IKeyAppointmentList {
  id: number;
  code: string;
  name: string;
}
